import { twMerge } from 'tailwind-merge';
import type { UIComponent } from '~/services/layout/index.ts';
import { type HorizontalListButtonPosition } from './hooks';
import { PreloadImage } from '~/components/preload-image';
import { getHorizontalListButtonMaxWidthClasses, type Styles } from './getters';

export function HorizontalListButton({
  direction,
  show,
  uiComponent,
  isNextFeedLoading,
  onClick,
  position,
  styles,
  defaultThemeV2Config,
}: {
  direction: 'left' | 'right';
  show: boolean;
  uiComponent: UIComponent;
  isNextFeedLoading: boolean;
  onClick: () => void;
  position: HorizontalListButtonPosition;
  styles: Styles;
  defaultThemeV2Config: any;
}) {
  if (!position.isMaxHeightReady) return <></>;

  const horizontalListBtnId = `horizontal-list-${direction}-btn-${uiComponent.id}`;

  return (
    <button
      className={twMerge(
        `group pointer-events-auto absolute z-10 h-full rounded-horizontal-list-arrow-border-radius bg-horizontal-list-arrow opacity-100 transition duration-500 ease-in-out hover:bg-horizontal-list-arrow-hover`,
        direction === 'left'
          ? 'horizontal-list-arrow-left left-0'
          : 'horizontal-list-arrow-right right-0',
        !show && 'pointer-events-none bg-horizontal-list-arrow-inactive',
        getHorizontalListButtonMaxWidthClasses({
          styles,
          defaultThemeV2Config,
          direction,
        })
      )}
      style={{
        maxHeight: position.maxHeight,
      }}
      key={horizontalListBtnId}
      data-testid={horizontalListBtnId}
      aria-disabled={!show}
      onClick={onClick}
    >
      <div className={twMerge(isNextFeedLoading && 'opacity-50')}>
        <PreloadImage tailwindImageClass="horizontal-list-left-arrow-asset-hover" />
        <PreloadImage tailwindImageClass="horizontal-list-left-arrow-asset-inactive" />
        <PreloadImage tailwindImageClass="horizontal-list-right-arrow-asset-hover" />
        <PreloadImage tailwindImageClass="horizontal-list-right-arrow-asset-inactive" />

        <div
          className={`h-horizontal-list-arrow w-horizontal-list-arrow ${
            direction === 'left'
              ? 'bg-horizontal-list-left-arrow-asset group-hover:bg-horizontal-list-left-arrow-asset-hover'
              : 'bg-horizontal-list-right-arrow-asset group-hover:bg-horizontal-list-right-arrow-asset-hover'
          } bg-contain bg-center bg-no-repeat ${
            !show && direction === 'left'
              ? 'bg-horizontal-list-left-arrow-asset-inactive'
              : ''
          } ${
            !show && direction === 'right'
              ? 'bg-horizontal-list-right-arrow-asset-inactive'
              : ''
          }`}
          key={`horizontal-list-${direction}-btn-icon-${uiComponent.id}`}
        />
      </div>
    </button>
  );
}
